/**
 * Centralized `data-role` identifiers.
 *
 * Notes:
 * - Keep values in sync with Blade/HTML data-role attributes.
 * - Do not change existing values casually (treat as public API).
 */

export class Roles {
    public static USER_REGISTER_FORM = "user-register-form";
    public static AVATAR_MODAL = "avatar-modal";
    public static AVATAR_IMAGE = "avatar-image";
    public static AVATAR_INPUT = "avatar-input";
    public static AVATAR_IMAGE_PICK = "avatar-image-pick";
    public static AVATAR_PREVIEW = "avatar-preview";
    public static SAVE_AVATAR_BTN = "save-avatar-btn";
    public static OPEN_AVATAR_MODAL = "open-avatar-modal";
    public static CLOSE_AVATAR_MODAL = "close-avatar-modal";
    public static CANCEL_AVATAR_BTN = "cancel-avatar-btn";
    public static AVATAR_MODAL_OVERLAY = "avatar-modal-overlay";
    public static TOGGLE_PROFILE_EDIT = "toggle-profile-edit";
    public static PROFILE_DISPLAY_MODE = "profile-display-mode";
    public static USER_PROFILE_TABS_ROOT = "user-profile-tabs-root";
    public static PROFILE_EDIT_MODE = "profile-edit-mode";
    public static PROFILE_EDIT_FORM = "profile-edit-form";
    public static CANCEL_PROFILE_EDIT = "cancel-profile-edit";
    public static SAVE_PROFILE_EDIT = "save-profile-edit";
    public static ACCOUNT_INFO_SECTION = "account-info-section";
    public static USER_FOLLOW = "user-follow";
    public static FOLLOW_TOGGLE_BTN = "follow-toggle-btn";
    public static FOLLOW_TOGGLE_LABEL = "follow-toggle-label";
    public static USER_PROFILE_TABS = "user-profile-tabs";
    public static USER_PROFILE_TAB_BUTTON = "user-profile-tab-button";
    public static USER_PROFILE_TAB_TRIGGER = "user-profile-tab-trigger";
    public static USER_PROFILE_TAB_PANEL = "user-profile-tab-panel";
    public static USER_PROFILE_TAB_LIST = "user-profile-tab-list";
    public static USER_PROFILE_TAB_COUNT = "user-profile-tab-count";
    public static FOLLOWERS_COUNT = "followers-count";
    public static USER_FOLLOW_AVATAR = "user-follow-avatar";
    public static USER_FOLLOW_NAME = "user-follow-name";
    public static USER_FOLLOW_POSTS_COUNT = "user-follow-posts-count";
    public static USER_FOLLOW_FOLLOWERS_COUNT = "user-follow-followers-count";
    public static USER_FOLLOW_FOLLOWERS_EMPTY = "user-follow-followers-empty";
    public static USER_FOLLOW_ATTRS = "user-follow-attrs";
    public static USER_FOLLOW_SKIN_TYPE = "user-follow-skin-type";
    public static USER_FOLLOW_SKIN_CONCERNS = "user-follow-skin-concerns";
    public static USER_FOLLOW_ITEM = "user-follow-item";
    public static USER_FOLLOW_POSTS_VALUE = "user-follow-posts-value";
    public static USER_FOLLOW_FOLLOWERS_VALUE = "user-follow-followers-value";
    public static USER_FOLLOW_SKIN_TYPE_VALUE = "user-follow-skin-type-value";
    public static USER_FOLLOW_SKIN_CONCERNS_VALUE = "user-follow-skin-concerns-value";
    public static USER_MODAL_LOADING = "user-modal-loading";
    public static FOLLOWERS_LIST = "followers-list";
    public static FOLLOWINGS_LIST = "followings-list";
    public static FAVORITES_LIST = "favorites-list";
    public static OPEN_POINT_HISTORY_ADJUST_MODAL = "open-point-history-adjust-modal";
    public static POINT_HISTORY_ADJUST_MODAL = "point-history-adjust-modal";
    public static POINT_HISTORY_ADJUST_MODAL_OVERLAY = "point-history-adjust-modal-overlay";
    public static CLOSE_POINT_HISTORY_ADJUST_MODAL = "close-point-history-adjust-modal";
    public static POINT_HISTORY_ADJUST_FORM = "point-history-adjust-form";
    public static POINT_HISTORY_ADJUST_MODE = "point-history-adjust-mode";
    public static POINT_HISTORY_ADJUST_HISTORY_ID = "point-history-adjust-history-id";
    public static POINT_HISTORY_ADJUST_AMOUNT_LABEL = "point-history-adjust-amount-label";
    public static POINT_HISTORY_ADJUST_AMOUNT_INPUT = "point-history-adjust-amount-input";
    public static POINT_HISTORY_ADJUST_RULE_FIELD = "point-history-adjust-rule-field";
    public static POINT_HISTORY_ADJUST_RULE_PICKER = "point-history-adjust-rule-picker";
    public static POINT_HISTORY_ADJUST_RULE_READONLY = "point-history-adjust-rule-readonly";
    public static POINT_HISTORY_ADJUST_NOTE_INPUT = "point-history-adjust-note-input";
    public static POINT_HISTORY_ADJUST_SUBMIT = "point-history-adjust-submit";
    public static POINT_HISTORY_INVALIDATE_BUTTON = "point-history-invalidate-button";
    public static POINT_HISTORY_INCLUDE_INVALID = "point-history-include-invalid";
    public static POINT_HISTORY_PANEL_TOTAL = "point-history-panel-total";
    public static USER_PROFILE_TAB_ROW = "user-profile-tab-row";
    public static USER_PROFILE_FAVORITE_CARD = "user-profile-favorite-card";
    public static USER_PROFILE_FAVORITE_REMOVE_BUTTON = "user-profile-favorite-remove-button";
    public static USER_PROFILE_FOLLOWING_CARD = "user-profile-following-card";
    public static USER_PROFILE_FOLLOWING_REMOVE_BUTTON = "user-profile-following-remove-button";
    public static EXPORT_FORM = "admin-export-form";
    public static EXPORT_STATUS = "admin-export-status";
    public static EXPORT_POSTS_CARD = "export-posts-card";
    public static EXPORT_POSTS_BOARD_ID_SELECT = "export-posts-board-id-select";
    public static EXPORT_POSTS_REVIEW_QUESTIONS_FIELD = "export-posts-review-questions-field";
    public static EXPORT_PRODUCTS_STATUS_SELECT = "export-products-status-select";
    public static IMPORT_FILE_FIELD = "import-file-field";
    public static IMPORT_FILE_INPUT = "import-file-input";
    public static IMPORT_FILE_CLEAR = "import-file-clear";
    public static MASTER_DATA_EDITOR = "master-data-editor";
    public static MASTER_DATA_EDIT_CONFIG = "master-data-edit-config";
    public static MASTER_DATA_MODAL = "master-data-modal";
    public static MASTER_DATA_MODAL_OVERLAY = "master-data-modal-overlay";
    public static CLOSE_MASTER_DATA_MODAL = "close-master-data-modal";
    public static MASTER_DATA_FORM = "master-data-form";
    public static USERS_ZIP_LOOKUP_BTN = "users-zip-lookup-btn";
    public static USERS_PREFECTURE_OPTIONS = "users-prefecture-options";
    public static USERS_PREFECTURE_PICKER = "users-prefecture-picker";
    public static USERS_PREFECTURE_DISPLAY = "users-prefecture-display";
    public static USERS_PREFECTURE_CLEAR = "users-prefecture-clear";
    public static USERS_PREFECTURE_MODAL_OVERLAY = "users-prefecture-modal-overlay";
    public static USERS_PREFECTURE_MODAL = "users-prefecture-modal";
    public static USERS_PREFECTURE_MODAL_CLOSE = "users-prefecture-modal-close";
    public static USERS_PREFECTURE_MODAL_FILTER = "users-prefecture-modal-filter";
    public static USERS_PREFECTURE_MODAL_LIST = "users-prefecture-modal-list";
    public static COUNTRY_FLAGS_MAP = "country-flags-map";
    public static COUNTRY_FLAG_PREVIEW = "country-flag-preview";
    public static PRODUCT_URL_OGP_SECTION = "product-url-ogp-section";
    public static PRODUCT_URL_OGP_PREVIEW = "product-url-ogp-preview";
    public static BRAND_URL_OGP_SECTION = "brand-url-ogp-section";
    public static BRAND_URL_OGP_PREVIEW = "brand-url-ogp-preview";
    public static BRAND_SNS_OGP_SECTION_PREFIX = "brand-sns-ogp-section-";
    public static BRAND_SNS_OGP_PREVIEW_PREFIX = "brand-sns-ogp-preview-";
    public static IMAGE_URL_PREVIEW = "image-url-preview";
    public static IMAGE_URL_PREVIEW_IMG = "image-url-preview-img";
    public static IMAGE_PATH_PREVIEW = "image-path-preview";
    public static IMAGE_PATH_PREVIEW_IMG = "image-path-preview-img";
    public static PRODUCT_IMAGE_PICK = "product-image-pick";
    public static PRODUCT_IMAGE_MAXIMIZE = "product-image-maximize";
    public static BRAND_IMAGE_PICK = "brand-image-pick";
    public static URL_CHECK = "url-check";
    public static SOCIAL_HANDLE_CHECK_STATUS = "social-handle-check-status";
    public static PRODUCT_CATEGORY_TREE_JSON = "product-category-tree-json";
    public static PRODUCT_CATEGORY_PICKER = "product-category-picker";
    public static PRODUCT_CATEGORY_DISPLAY = "product-category-display";
    public static PRODUCT_CATEGORY_PARENT_SELECT = "product-category-parent-select";
    public static PRODUCT_CATEGORY_CHILD_SELECT = "product-category-child-select";
    public static MASTER_EDIT_OPEN = "master-edit-open";
    public static MASTER_ADD_OPEN = "master-add-open";
    public static MASTER_DELETE = "master-delete";
    public static MASTER_MERGE_OPEN = "master-merge-open";
    public static MERGE_TOOL_MODAL = "merge-tool-modal";
    public static MERGE_TOOL_MODAL_OVERLAY = "merge-tool-modal-overlay";
    public static CLOSE_MERGE_TOOL_MODAL = "close-merge-tool-modal";
    public static POST_PANEL = "post-panel";
    public static POST_TAB = "post-tab";
    public static POST_CREATE_FORM = "post-create-form";
    public static IMAGE_UPLOAD = "image-upload";
    public static VIDEO_UPLOAD = "video-upload";
    public static PREVIEW_BODY = "preview-body";
    public static IMAGE_MANAGER = "image-manager";
    public static IMAGE_LIST = "image-list";
    public static OGP_PREVIEW_SECTION = "ogp-preview-section";
    public static REVIEW_QUESTIONS_PREVIEW = "review-questions-preview";
    public static IMAGE_GRID = "image-grid";
    public static VIDEO_LIST = "video-list";
    public static VIDEO_GRID = "video-grid";
    public static PICKER_BODY = "picker-body";
    public static PICKER_ADD = "picker-add";
    public static MEDIA_TILE = "media-tile";
    public static MEDIA_CONTROLS = "media-controls";
    public static MEDIA_ROTATE = "media-rotate";
    public static MEDIA_REMOVE = "media-remove";
    public static MEDIA_REMOVED_INDICATOR = "media-removed-indicator";
    public static VIDEO_MANAGER = "video-manager";
    public static POST_PREVIEW_ROOT = "post-preview-root";
    public static POST_TITLE = "post-title";
    public static POST_STATUS_SELECT = "post-status-select";
    public static REVIEW_QUESTION_LABEL = "review-question-label";
    public static REVIEW_SINGLE_SELECT = "review-single-select";
    public static REVIEW_OPTION_LABEL = "review-option-label";
    public static REVIEW_OPTION_TEXT = "review-option-text";
    public static CHOICES_FIELD = "choices-field";
    public static CHOICES_CONTROL = "choices-control";
    public static RATING_INPUT = "rating-input";
    public static RATING_STAR = "rating-star";
    public static REVIEW_ANSWER = "review-answer";
    public static POST_CONTENT = "post-content";
    public static RATING_SLIDER = "rating-slider";
    public static TRANSLATION_TOGGLE = "translation-toggle";
    public static BOARD_MEDIA_PLACEHOLDER = "board-media-placeholder";
    public static POST_PRODUCT_THUMB_PLACEHOLDER = "post-product-thumb-placeholder";
    public static POST_SUBMIT = "post-submit";
    public static REVIEW_AGREEMENT = "review-agreement";
    public static PREVIEW_BTN = "preview-btn";
    public static BTN_ADD_VIDEOS = "btn-add-videos";
    public static POST_PRODUCT_THUMB = "post-product-thumb";
    public static POST_PRODUCT_THUMB_LINK = "post-product-thumb-link";
    public static EXISTING_IMAGE_TILE = "existing-image-tile";
    public static EXISTING_VIDEO_TILE = "existing-video-tile";
    public static SNS_LINKS_LIST = "sns-links-list";
    public static SNS_LINK_INPUT = "sns-link-input";
    public static WYSIWYG_EDITOR = "wysiwyg-editor";
    public static WYSIWYG_TOOLBAR = "wysiwyg-toolbar";
    public static WYSIWYG_CONTENT = "wysiwyg-content";
    public static WYSIWYG_IMAGE_TOOLBAR = "wysiwyg-image-toolbar";
    public static POST_CREATE_PRODUCT_SUMMARY_DETAILS = "post-create-product-summary-details";
    public static POST_CREATE_PRODUCT_SUMMARY_TOGGLE = "post-create-product-summary-toggle";
    public static POST_CREATE_PRODUCT_SUMMARY_BODY = "post-create-product-summary-body";
    public static POST_CREATE_PRODUCT_SUMMARY_BODY_INNER = "post-create-product-summary-body-inner";
    public static YOUTUBE_LINKS_CONTAINER = "youtube-links-container";
    public static YOUTUBE_LINKS_LIST = "youtube-links-list";
    public static YOUTUBE_PREVIEW = "youtube-preview";
    public static YOUTUBE_PLAY_BUTTON = "youtube-play-button";
    public static FACEBOOK_PREVIEW = "facebook-preview";
    public static FACEBOOK_CUSTOMER_CHAT = "facebook-customer-chat";
    public static LOGIN_HISTORY_TRIGGER = "login-history-trigger";
    public static LOGIN_HISTORY_MODAL = "login-history-modal";
    public static LOGIN_HISTORY_MODAL_OVERLAY = "login-history-modal-overlay";
    public static CLOSE_LOGIN_HISTORY_MODAL = "close-login-history-modal";
    public static LOGIN_HISTORY_MODAL_TITLE = "login-history-modal-title";
    public static LOGIN_HISTORY_MODAL_SPINNER = "login-history-modal-spinner";
    public static LOGIN_HISTORY_MODAL_STATUS = "login-history-modal-status";
    public static LOGIN_HISTORY_MODAL_BODY = "login-history-modal-body";
    public static SEARCH_CATEGORY_MODAL_OVERLAY = "search-category-modal-overlay";
    public static SEARCH_CATEGORY_MODAL = "search-category-modal";
    public static SEARCH_CATEGORY_MODAL_CLOSE = "search-category-modal-close";
    public static SEARCH_CATEGORY_MODAL_FILTER = "search-category-modal-filter";
    public static SEARCH_CATEGORY_MODAL_LIST = "search-category-modal-list";
    public static SEARCH_CATEGORY_MODAL_SHOW_ALL_TOGGLE = "search-category-modal-show-all-toggle";
    public static SEARCH_CATEGORY_MODAL_EDIT_OPEN = "search-category-modal-edit-open";
    public static CATEGORY_REVIEW_EDITOR_OVERLAY = "category-review-editor-overlay";
    public static CATEGORY_REVIEW_EDITOR_MODAL = "category-review-editor-modal";
    public static CATEGORY_REVIEW_EDITOR_WINDOW = "category-review-editor-window";
    public static CATEGORY_REVIEW_EDITOR_REVIEW_SETTINGS_WINDOW = "category-review-editor-review-settings-window";
    public static CATEGORY_REVIEW_EDITOR_CLOSE = "category-review-editor-close";
    public static CATEGORY_REVIEW_EDITOR_TAB_CATEGORY = "category-review-editor-tab-category";
    public static CATEGORY_REVIEW_EDITOR_TAB_QUESTION = "category-review-editor-tab-question";
    public static CATEGORY_REVIEW_EDITOR_TAB_REVIEW = "category-review-editor-tab-review";
    public static CATEGORY_REVIEW_EDITOR_PANEL_CATEGORY = "category-review-editor-panel-category";
    public static CATEGORY_REVIEW_EDITOR_PANEL_QUESTION = "category-review-editor-panel-question";
    public static CATEGORY_REVIEW_EDITOR_PANEL_REVIEW = "category-review-editor-panel-review";
    public static CATEGORY_REVIEW_EDITOR_SAVE = "category-review-editor-save";
    public static CATEGORY_REVIEW_EDITOR_STATUS = "category-review-editor-status";
    public static SEARCH_CATEGORY_PICKER = "search-category-picker";
    public static SEARCH_CATEGORY_CHIPS = "search-category-chips";
    public static SEARCH_CATEGORY_OPEN = "search-category-open";
    public static SEARCH_BRAND_MODAL_OVERLAY = "search-brand-modal-overlay";
    public static SEARCH_BRAND_MODAL = "search-brand-modal";
    public static SEARCH_BRAND_MODAL_CLOSE = "search-brand-modal-close";
    public static SEARCH_BRAND_MODAL_FILTER = "search-brand-modal-filter";
    public static SEARCH_BRAND_MODAL_POPULAR = "search-brand-modal-popular";
    public static SEARCH_BRAND_MODAL_ALL = "search-brand-modal-all";
    public static SEARCH_BRAND_MODAL_SHOW_ALL_TOGGLE = "search-brand-modal-show-all-toggle";
    public static SEARCH_BRAND_PICKER = "search-brand-picker";
    public static SEARCH_BRAND_CHIPS = "search-brand-chips";
    public static SEARCH_USER_MODAL_OVERLAY = "search-user-modal-overlay";
    public static SEARCH_USER_MODAL = "search-user-modal";
    public static SEARCH_USER_MODAL_CLOSE = "search-user-modal-close";
    public static SEARCH_USER_MODAL_FILTER = "search-user-modal-filter";
    public static SEARCH_USER_MODAL_LIST = "search-user-modal-list";
    public static SEARCH_PRODUCT_UPDATED_BY_MODAL_OVERLAY = "search-product-updated-by-modal-overlay";
    public static SEARCH_PRODUCT_UPDATED_BY_MODAL = "search-product-updated-by-modal";
    public static SEARCH_PRODUCT_UPDATED_BY_MODAL_CLOSE = "search-product-updated-by-modal-close";
    public static SEARCH_PRODUCT_UPDATED_BY_MODAL_FILTER = "search-product-updated-by-modal-filter";
    public static SEARCH_PRODUCT_UPDATED_BY_MODAL_LIST = "search-product-updated-by-modal-list";
    public static SEARCH_USER_PICKER = "search-user-picker";
    public static SEARCH_USER_CHIPS = "search-user-chips";
    public static SEARCH_PRODUCT_UPDATED_BY_PICKER = "search-product-updated-by-picker";
    public static SEARCH_PRODUCT_UPDATED_BY_CHIPS = "search-product-updated-by-chips";
    public static SEARCH_ADVANCED_TOGGLE = "search-advanced-toggle";
    public static SEARCH_ADVANCED_PANEL = "search-advanced-panel";
    public static SEARCH_MENU_PERSIST_TOGGLE = "search-menu-persist-toggle";
    public static SNS_LIVE_PREVIEW = "sns-live-preview";
    public static OGP_LIVE_PREVIEW = "ogp-live-preview";
    public static OGP_PREVIEW_CARD = "ogp-preview-card";
    public static SNS_PREVIEW_TAB = "sns-preview-tab";
    public static OGP_PREVIEW_TAB = "ogp-preview-tab";
    public static SNS_PREVIEW_TILES_GRID = "sns-preview-tiles-grid";
    public static SNS_PREVIEW_TILE = "sns-preview-tile";
    public static SNS_PREVIEW_THUMB = "sns-preview-thumb";
    public static SNS_EMBED = "sns-embed";
    public static PREVIEW_RICH_HOST = "preview-rich-host";
    public static PREVIEW_TITLE = "preview-title";
    public static CONTENT_IMAGES_LIST = "content-images-list";
    public static IMAGES_PREVIEW_GRID = "images-preview-grid";
    public static VIDEOS_PREVIEW_GRID = "videos-preview-grid";
    public static SNS_PREVIEW_GRID = "sns-preview-grid";
    public static SNS_OPEN = "sns-open";
    public static SNS_CLOSE = "sns-close";
    public static SNS_LINKS_PANEL = "sns-links-panel";
    public static SNS_LINKS_EDITOR = "sns-links-editor";
    public static SNS_SAVE = "sns-save";
    public static SNS_EDIT = "sns-edit";
    public static SNS_ADD_TILE = "sns-add-tile";
    public static SNS_LINK_ITEM = "sns-link-item";
    public static SNS_TILE_REMOVE = "sns-tile-remove";
    public static SNS_PREVIEW_ANIMATIONS = "sns-preview-animations";
    public static MULTILANG_TEXT = "multilang-text";
    public static MULTILANG_TARGET = "multilang-target";
    public static MULTILANG_SOURCE = "multilang-source";
    public static JOBS_DASHBOARD = "jobs-dashboard";

    public static ADMIN_DASHBOARD_ROOT = "admin-dashboard-root";

    public static ADMIN_DASHBOARD_GRANULARITY_DAILY = "admin-dashboard-granularity-daily";

    public static ADMIN_DASHBOARD_GRANULARITY_MONTHLY = "admin-dashboard-granularity-monthly";

    public static ADMIN_DASHBOARD_STATUS = "admin-dashboard-status";

    public static ADMIN_DASHBOARD_TABS = "admin-dashboard-tabs";

    public static ADMIN_DASHBOARD_PANELS = "admin-dashboard-panels";

    public static USERS_ADMIN_ROOT = "users-admin-root";
    public static USERS_ADMIN_DATA = "users-admin-data";
    public static USERS_ADMIN_STATUS = "users-admin-status";
    public static USERS_ADMIN_COUNT = "users-admin-count";
    public static USERS_ADMIN_SEARCH = "users-admin-search";
    public static USERS_ADMIN_ROLE_FILTER = "users-admin-role-filter";
    public static USERS_ADMIN_STATUS_FILTER = "users-admin-status-filter";
    public static USERS_ADMIN_INCLUDE_DUMMY_FILTER = "users-admin-include-dummy-filter";
    public static USERS_ADMIN_LIST = "users-admin-list";
    public static USERS_ADMIN_EDIT = "users-admin-edit";
    public static COMMENT_TEXT = "comment-text";
    public static COMMENT_FORM = "comment-form";
    public static COMMENTS_LIST = "comments-list";
    public static COMMENT_ITEM = "comment-item";
    public static COMMENT_EDIT_FORM = "comment-edit-form";
    public static COMMENT_EDIT_FORM_INNER = "comment-edit-form-inner";
    public static COMMENT_EDIT_TEXTAREA = "comment-edit-textarea";
    public static COMMENT_REPLY_FORM = "reply-form";
    public static COMMENT_REPLY_FORM_INNER = "comment-reply-form-inner";
    public static COMMENT_REPLY_TEXTAREA = "comment-reply-textarea";
    public static COMMENT_REPLY_TOGGLE = "comment-reply-toggle";
    public static COMMENT_TEXTAREA = "comment-textarea";
    public static COMMENT_REPLIES = "replies";
    public static USER_STARS_PREVIEW = "user-stars-preview";
    public static USER_RATING_AVERAGE = "user-rating-average";
    public static USER_RATING_COUNT = "user-rating-count";
    public static PRODUCT_RATING_AVERAGE = "product-rating-average";
    public static PRODUCT_REVIEW_COUNT = "product-review-count";
    public static LANGUAGE_SELECT = "language-select";
    public static INFO_TOOLTIP_SOURCE = "info-tooltip-source";
    public static PRODUCT_SEARCH_FORM = "product-search-form";
    public static BOARD_SEARCH_FORM = "board-search-form";
    public static SEARCH_CATEGORY_SELECT = "search-category-select";
    public static SEARCH_BRAND_SELECT = "search-brand-select";
    public static SEARCH_PRODUCT_SELECT = "search-product-select";
    public static SEARCH_KEYWORD_SELECT = "search-keyword-select";
    public static SEARCH_FORM_INPUT = "search-form-input";
    public static SEARCH_FORM_CLEAR = "search-form-clear";
    public static SEARCH_SUGGEST_DROPDOWN = "search-suggest-dropdown";
    public static SEARCH_SUGGEST_ITEM = "search-suggest-item";
    public static SEARCH_SUGGEST_TEXT = "search-suggest-text";
    public static SEARCH_MENU_OVERLAY = "search-menu-overlay";
    public static SEARCH_MENU_CONTAINER = "search-menu-container";
    public static SEARCH_MENU_POST_PRODUCT_PICKER_CONTAINER = "search-menu-post-product-picker-container";
    public static SEARCH_MENU_ROOT = "search-menu-root";
    public static SEARCH_MENU_SCROLL_BODY = "search-menu-scroll-body";
    public static SEARCH_MENU_RESULTS = "search-menu-results";
    public static SEARCH_MENU_CONFIRM = "search-menu-confirm";
    public static SEARCH_MENU_CLEAR_ACTION = "search-menu-clear-action";
    public static SEARCH_MENU_KEYWORD_CLEAR = "search-menu-keyword-clear";
    public static SEARCH_MENU_CLOSE = "search-menu-close";
    public static SEARCH_MENU_TARGET = "search-menu-target";
    public static SEARCH_MENU_TARGET_FIELD_GROUP = "search-menu-target-field-group";
    public static SEARCH_ADVANCED_TABS = "search-advanced-tabs";
    public static SEARCH_ADVANCED_TAB = "search-advanced-tab";
    public static SEARCH_ADVANCED_TAB_PANEL = "search-advanced-tab-panel";
    public static PRODUCT_SORT_TOGGLE = "product-sort-toggle";
    public static PRODUCT_SORT_TOGGLE_BTN = "product-sort-toggle-btn";
    public static SEARCH_MENU_SET_PRODUCT = "search-menu-set-product";
    public static POST_PRODUCT_LINKER = "post-product-linker";
    public static POST_PRODUCT_LINKER_VIEW = "post-product-linker-view";
    public static POST_PRODUCT_OPEN = "post-product-open";
    public static POST_PRODUCT_CLEAR = "post-product-clear";
    public static POST_PRODUCT_ID = "post-product-id";
    public static POST_PRODUCT_PREVIEW = "post-product-preview";
    public static POST_PRODUCT_SEARCH_INPUT = "post-product-search-input";
    public static ELEMENT_MODAL = "element-modal";
    public static ELEMENT_MODAL_OVERLAY = "element-modal-overlay";
    public static ELEMENT_MODAL_TRIGGER = "element-modal-trigger";
    public static ELEMENT_MODAL_HEADER = "element-modal-header";
    public static ELEMENT_MODAL_BODY = "element-modal-body";
    public static ELEMENT_MODAL_FOOTER = "element-modal-footer";
    public static ELEMENT_MODAL_TITLE = "element-modal-title";
    public static ELEMENT_MODAL_CLOSE = "element-modal-close";
    public static POSTS_LIST = "posts-list";
    public static POST_CARD = "post-card";
    public static POST_CARD_BODY = "post-card-body";
    public static POST_CARD_TITLE = "post-card-title";
    public static POST_CARD_REVIEW_DETAILS_TOGGLE = "post-card-review-details-toggle";
    public static POST_CARD_REVIEW_DETAILS_BODY = "post-card-review-details-body";
    public static POST_CONTENT_DISPLAY = "post-content-display";
    public static POST_DETAIL = "post-detail";
    public static POST_DETAIL_HIDDEN = "post-detail-hidden";
    public static POST_ACTION_EDIT = "post-action-edit";
    public static POST_ACTION_DELETE = "post-action-delete";
    public static POST_ACTION_SHARE = "post-action-share";
    public static POST_DETAIL_HEADER = "post-detail-header";
    public static POST_DETAIL_TITLE = "post-detail-title";
    public static POST_AUTHOR_NAME = "post-author-name";
    public static POST_CREATED_AT = "post-created-at";
    public static POST_DROPDOWN_CONTAINER = "post-dropdown-container";
    public static POST_ATTACHMENTS_SECTION = "post-attachments-section";
    public static POST_ATTACHMENT_BLOCK = "post-attachment-block";
    public static POST_ATTACHMENT_CONTENT = "post-attachment-content";
    public static POST_ATTACHMENT_IMAGE_ITEM = "post-attachment-image-item";
    public static POST_ATTACHMENT_IMAGE = "post-attachment-image";
    public static POST_ATTACHMENT_VIDEO_ITEM = "post-attachment-video-item";
    public static POST_ATTACHMENT_VIDEO = "post-attachment-video";
    public static POST_DETAIL_CONTENT = "post-detail-content";
    public static POST_DETAIL_MEDIA_PREVIEW = "post-detail-media-preview";
    public static POST_DETAIL_MEDIA_SNS_MEDIA = "post-detail-media-sns-media";
    public static SNS_CONTENT = "sns-content";
    public static POST_SNS_LINKS_DATA = "post-sns-links-data";
    public static BOARD_MEDIA_AREA = "board-media-area";
    public static BOARD_IMAGES_GRID = "board-images-grid";
    public static BOARD_VIDEO_WRAP = "board-video-wrap";
    public static BOARD_VIDEO_PREVIEW = "board-video-preview";
    public static LIKE_BUTTON = "like-button";
    public static LIKE_ICON = "like-icon";
    public static LIKE_COUNT = "like-count";
    public static POST_CREATE_CANCEL = "post-create-cancel";
    public static POST_EDIT_FORM = "post-edit-form";
    public static POST_EDIT_FORM_INNER = "post-edit-form-inner";
    public static POST_EDIT_CANCEL = "post-edit-cancel";
    public static POST_EDIT_SAVE = "post-edit-save";
    public static COMMENT_EDIT_CANCEL = "comment-edit-cancel";
    public static COMMENTS_SECTION = "comments-section";
    public static COMMENT_COUNT_ACTION = "comment-count-action";
    public static COMMENT_COUNT_HEADER = "comment-count-header";
    public static COMMENT_DROPDOWN_CONTAINER = "comment-dropdown-container";
    public static COMMENT_EMPTY = "comment-empty";
    public static COMMENT_EMPTY_YET = "comment-empty-yet";
    public static COMMENT_TIMESTAMP = "comment-timestamp";
    public static COMMENT_REPLIES_LOADING = "comment-replies-loading";
    public static POST_MENU_BUTTON = "post-menu-button";
    public static COMMENT_MENU_BUTTON = "comment-menu-button";
    public static POST_MENU = "post-menu";
    public static COMMENT_MENU = "comment-menu";
    public static DROPDOWN_MENU_ITEM = "dropdown-menu-item";
    public static COMMENT_ACTION_EDIT = "comment-action-edit";
    public static COMMENT_ACTION_DELETE = "comment-action-delete";
    public static READ_COUNT = "read-count";
    public static POST_RECOMMEND_BTN = "post-recommend-btn";
    public static POST_RECOMMEND_MODAL_LIST = "post-recommend-modal-list";
    public static POST_RECOMMEND_BADGE_RANK = "post-recommend-badge-rank";
    public static POST_RECOMMEND_BADGE_SPINNER = "post-recommend-badge-spinner";
    public static POST_RECOMMEND_MODAL_OVERLAY = "post-recommend-modal-overlay";
    public static POST_RECOMMEND_MODAL = "post-recommend-modal";
    public static POST_RECOMMEND_MODAL_TITLE = "post-recommend-modal-title";
    public static POST_RECOMMEND_MODAL_BOARD_ID = "post-recommend-modal-board-id";
    public static POST_RECOMMEND_MODAL_CLOSE = "post-recommend-modal-close";
    public static USER_RECOMMEND_BTN = "user-recommend-btn";
    public static USER_RECOMMEND_MODAL_OVERLAY = "user-recommend-modal-overlay";
    public static USER_RECOMMEND_MODAL = "user-recommend-modal";
    public static USER_RECOMMEND_MODAL_CLOSE = "user-recommend-modal-close";
    public static USER_RECOMMEND_MODAL_LIST = "user-recommend-modal-list";
    public static USER_RECOMMEND_MODAL_CLEAR = "user-recommend-modal-clear";
    public static USER_RECOMMEND_BADGE_RANK = "user-recommend-badge-rank";
    public static BRAND_CARD = "brand-card";
    public static BRAND_RECOMMEND_BTN = "brand-recommend-btn";
    public static BRAND_RECOMMEND_BADGE_RANK = "brand-recommend-badge-rank";
    public static BRAND_RECOMMEND_MODAL_OVERLAY = "brand-recommend-modal-overlay";
    public static BRAND_RECOMMEND_MODAL = "brand-recommend-modal";
    public static BRAND_RECOMMEND_MODAL_CLOSE = "brand-recommend-modal-close";
    public static BRAND_RECOMMEND_MODAL_BODY = "brand-recommend-modal-body";
    public static BRAND_RECOMMEND_MODAL_LIST = "brand-recommend-modal-list";
    public static PRODUCT_CARD = "product-card";
    public static PRODUCT_LIKE_BTN = "product-like-btn";
    public static PRODUCT_RECOMMEND_BTN = "product-recommend-btn";
    public static PRODUCT_CARD_TRUNCATE = "product-card-truncate";
    public static PRODUCT_LIST_IMAGE_ZOOM_TOGGLE = "product-list-image-zoom-toggle";
    public static PRODUCT_RECOMMEND_MODAL_OVERLAY = "product-recommend-modal-overlay";
    public static PRODUCT_RECOMMEND_MODAL = "product-recommend-modal";
    public static PRODUCT_RECOMMEND_MODAL_CLOSE = "product-recommend-modal-close";
    public static PRODUCT_RECOMMEND_MODAL_BODY = "product-recommend-modal-body";
    public static PRODUCT_RECOMMEND_MODAL_LIST = "product-recommend-modal-list";
    public static PRODUCT_RECOMMEND_BADGE_SPINNER = "product-recommend-badge-spinner";
    public static NOTIFICATIONS_POPOVER = "notifications-popover";
    public static NOTIFICATIONS_POPOVER_LOADING = "notifications-popover-loading";
    public static NOTIFICATIONS_POPOVER_LIST = "notifications-popover-list";
    public static NOTIFICATIONS_POPOVER_EMPTY = "notifications-popover-empty";
    public static NOTIFICATIONS_UNREAD_BADGE = "notifications-unread-badge";
    public static NAVBAR_CONTENT = "navbar-content";
    public static NAVBAR_HAMBURGER_TOGGLE = "navbar-hamburger-toggle";
    public static NAVBAR_COLLAPSIBLE = "navbar-collapsible";
    public static NAVBAR_SETTINGS_TOGGLE = "navbar-settings-toggle";
    public static NAVBAR_SETTINGS_POPOVER = "navbar-settings-popover";
    public static NAVBAR_HAMBURGER_OVERLAY = "navbar-hamburger-overlay";
    public static NOTIFICATIONS_OVERLAY = "notifications-overlay";
    public static NAVBAR_SETTINGS_OVERLAY = "navbar-settings-overlay";
    public static NAVBAR_TIKTOK_CONNECT = "navbar-tiktok-connect";
    public static RANKINGS_MONTHLY_TABS = "rankings-monthly-tabs";
    public static RANKINGS_MONTHLY_TAB = "rankings-monthly-tab";
    public static RANKINGS_MONTHLY_PANEL = "rankings-monthly-panel";
    public static RANKINGS_MONTHLY_PARENT_TABS = "rankings-monthly-parent-tabs";
    public static RANKINGS_MONTHLY_PARENT_TAB = "rankings-monthly-parent-tab";
    public static RANKINGS_MONTHLY_PARENT_PANEL = "rankings-monthly-parent-panel";
    public static RANKINGS_MONTHLY_MONTH_PICKER = "rankings-monthly-month-picker";
    public static RANKINGS_MONTHLY_MONTH_PREV = "rankings-monthly-month-prev";
    public static RANKINGS_MONTHLY_MONTH_NEXT = "rankings-monthly-month-next";
    public static HOME_RANKING_PRODUCT_TABS = "home-ranking-product-tabs";
    public static HOME_RANKING_PRODUCT_TAB = "home-ranking-product-tab";
    public static HOME_RANKING_PRODUCT_PANEL = "home-ranking-product-panel";
    public static HORIZONTAL_SLIDER = "horizontal-slider";
    public static HORIZONTAL_SLIDER_TRACK = "horizontal-slider-track";
    public static HORIZONTAL_SLIDER_PREV = "horizontal-slider-prev";
    public static HORIZONTAL_SLIDER_NEXT = "horizontal-slider-next";
    public static HORIZONTAL_SLIDER_DOTS = "horizontal-slider-dots";
    public static HORIZONTAL_SLIDER_DOT = "horizontal-slider-dot";
    public static MAXIMIZE_VIEWER_MODAL = "maximize-viewer-modal";
    public static MAXIMIZE_VIEWER_OVERLAY = "maximize-viewer-overlay";
    public static MAXIMIZE_VIEWER_BACKDROP = "maximize-viewer-backdrop";
    public static MAXIMIZE_VIEWER_CLOSE = "maximize-viewer-close";
    public static MAXIMIZE_VIEWER_IFRAME = "maximize-viewer-iframe";
    public static MAXIMIZE_VIEWER_IMAGE = "maximize-viewer-image";
    public static MAXIMIZE_VIEWER_VIDEO = "maximize-viewer-video";
    public static ABOUT_US_TABS = "about-us-tabs";
    public static ABOUT_US_TAB = "about-us-tab";
    public static ABOUT_US_PANEL = "about-us-panel";
    public static FILTER_SIDEBAR_WRAPPER = "filter-sidebar-wrapper";
    public static FILTER_SIDEBAR = "filter-sidebar";
    public static FILTER_SIDEBAR_TOGGLE = "filter-sidebar-toggle";
    public static FILTER_SIDEBAR_MOBILE_TOGGLE = "filter-sidebar-mobile-toggle";
    public static NAVBAR_ADMIN_SEARCH_TRIGGER = "navbar-admin-search-trigger";
    public static FILTER_SIDEBAR_DRAG_HANDLE = "filter-sidebar-drag-handle";
    public static FILTER_SIDEBAR_CAT_TOGGLE = "filter-sidebar-cat-toggle";
    public static FILTER_SIDEBAR_CLEAR = "filter-sidebar-clear";
    public static FILTER_SIDEBAR_BRAND_SEARCH = "filter-sidebar-brand-search";
    public static FILTER_SIDEBAR_BRAND_TOGGLE = "filter-sidebar-brand-toggle";
    public static FILTER_SIDEBAR_CAT_SEARCH = "filter-sidebar-cat-search";
    public static FILTER_SIDEBAR_CAT_BODY_TOGGLE = "filter-sidebar-cat-body-toggle";
    public static FILTER_SIDEBAR_KEYWORD_SEARCH = "filter-sidebar-keyword-search";
    public static FILTER_SIDEBAR_KEYWORD_CLEAR = "filter-sidebar-keyword-clear";
    public static FILTER_SIDEBAR_KEYWORD_SUBMIT = "filter-sidebar-keyword-submit";
    public static FILTER_SIDEBAR_CAT_PICKER_BTN = "filter-sidebar-cat-picker-btn";
    public static FILTER_SIDEBAR_CAT_PICKER_LABEL = "filter-sidebar-cat-picker-label";
    public static FILTER_SIDEBAR_CAT_PICKER_PANEL = "filter-sidebar-cat-picker-panel";
    public static FILTER_SIDEBAR_CAT_PICKER_FILTER = "filter-sidebar-cat-picker-filter";
    public static FILTER_SIDEBAR_CAT_PICKER_FILTER_CLEAR = "filter-sidebar-cat-picker-filter-clear";
    public static FILTER_SIDEBAR_CAT_PICKER_ITEM = "filter-sidebar-cat-picker-item";
    public static FILTER_SIDEBAR_CAT_PICKER_GROUP = "filter-sidebar-cat-picker-group";
    public static FILTER_SIDEBAR_CAT_NAME_GROUP = "filter-sidebar-cat-name-group";
    public static FILTER_SIDEBAR_CAT_CHILDREN = "filter-sidebar-cat-children";
    public static FILTER_SIDEBAR_BRAND_BODY = "filter-sidebar-brand-body";
    public static BRANDS_SIDEBAR = "brands-sidebar";
    public static BRANDS_SIDEBAR_FILTER_ITEM = "brands-sidebar-filter-item";
    public static BRANDS_SIDEBAR_KEYWORD = "brands-sidebar-keyword";
    public static BRANDS_SIDEBAR_KEYWORD_CLEAR = "brands-sidebar-keyword-clear";
    public static BRANDS_SIDEBAR_KEYWORD_SUBMIT = "brands-sidebar-keyword-submit";
    public static BRANDS_SIDEBAR_CLEAR = "brands-sidebar-clear";
    public static BRANDS_SIDEBAR_TOGGLE = "brands-sidebar-toggle";
    public static BRANDS_SIDEBAR_PANEL = "brands-sidebar-panel";
}
